import { types, utils } from 'utils';

export const PSDetails = (year: string, row: types.PollingData) => `
    <html>
        <head>
            <title>Polling Station Details</title>
            <style>
                body {
                    font-family: Courier;
                    background-color: #f4f4f4;
                    margin: 0;
                    padding: 20px;
                }
                h1 {
                    color: #333;
                }
                .charts, .details {
                    background-color: #fff;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    padding: 20px;
                }
                .details {
                    max-width: 500px;
                    margin: 0 20px;
                    float: left;
                }
                .charts {
                    float: left;
                    width: 300px;                    
                }
                .charts canvas {
                    margin-bottom: 20px;
                }
                p {
                    font-size: 16px;
                    margin: 10px 0;
                    color: #666;
                }
                strong {
                    color: #333;
                }
            </style>
            <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
            
            <script>
                const createChart = (id, data, title) => {
                    const chartData = {
                        labels: ["NDC", "NPP", "Others"],
                        datasets: [
                            {
                                data,
                                labels: ["NDC", "NPP", "Others"],
                                backgroundColor: [
                                    "rgba(53, 121, 55, 1)",
                                    "rgba(7, 1, 151, 1)",
                                    "rgba(250, 8, 31, 1)",
                                ],
                                borderColor: [
                                    "rgba(53, 121, 55, 1)",
                                    "rgba(7, 1, 151, 1)",
                                    "rgba(250, 8, 31, 1)",
                                ],
                            },
                        ],
                    };
                    const chartOptions = {
                        responsive: true,
                        plugins: {
                            title: {
                                display: true,
                                text: title,
                            },
                            legend: {
                                display: false,
                                position: "bottom",
                            },
                        },
                    };
                    const ctx = document.getElementById(id);
                    new window.Chart(ctx, { type: 'bar', data: chartData, options: chartOptions });
                }
                document.addEventListener('load', function(e) {
                    createChart('voteDistributionChart_prez', [${row.ndcprez},${row.nppprez},${row.otherprez}], 'Presidential');
                    createChart('voteDistributionChart_parl', [${row.ndcparl},${row.nppparl},${row.otherparl}], 'Parliamentary');
                }, true);
            </script>
        </head>
        <body>
            <div class="charts">
                <canvas id="voteDistributionChart_prez"></canvas>
                <hr />
                <canvas id="voteDistributionChart_parl"></canvas>
            </div>
            <div class="details">
                <h1>${year} - ${row.pscode}</h1>
                <p><strong>Codes:</strong> ${row.pscode}</p>
                <p><strong>Name:</strong> ${row.psname}</p>
                <p><strong>Region:</strong> ${row.region}</p>
                <p><strong>Constituency:</strong> ${row.constituency}</p>
                <p><strong>Total Registered Voters:</strong> ${utils.numberFormat(row.regvoters)}</p>
                <hr />
                <h3>Presidential Details</h3>
                <p><strong>NPP Votes:</strong> ${utils.numberFormat(row.nppprez)}</p>
                <p><strong>NDC Votes:</strong> ${utils.numberFormat(row.ndcprez)}</p>
                <p><strong>Others Votes:</strong> ${utils.numberFormat(row.otherprez)}</p>
                <p><strong>Rejected Votes:</strong> ${utils.numberFormat(row.rejprez)}</p>
                <p><strong>Winner:</strong> ${row.prezwinner}</p>
                <hr />
                <h3>Parliamentary Details</h3>
                <p><strong>NPP Votes:</strong> ${utils.numberFormat(row.nppparl)}</p>
                <p><strong>NDC Votes:</strong> ${utils.numberFormat(row.ndcparl)}</p>
                <p><strong>Others Votes:</strong> ${utils.numberFormat(row.otherparl)}</p>
                <p><strong>Rejected Votes:</strong> ${utils.numberFormat(row.rejparl)}</p>
                <p><strong>Winner:</strong> ${row.parlwinner}</p>
            </div>
        </body>
    </html>
`   ;